module.exports = __webpack_public_path__ + "static/media/pollys-oh.7cca9841.png";